(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function sleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function byIdPrefix(root, prefix) {
    return qs(root, '[id^="' + prefix + '"]');
  }

  function dispatchChange(el) {
    if (!el) return;
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function trim(value) {
    return String(value == null ? '' : value).trim();
  }

  function generateConfigId() {
    return 'AV-' + Date.now().toString(36).toUpperCase() + '-' + Math.random().toString(36).slice(2, 8).toUpperCase();
  }

  function parseJson(el, fallback) {
    if (!el) return fallback;

    try {
      return JSON.parse(trim(el.textContent)) || fallback;
    } catch (error) {
      return fallback;
    }
  }

  function injectEditStyles() {
    if (document.getElementById('av-edit-mode-styles')) return;

    var style = document.createElement('style');
    style.id = 'av-edit-mode-styles';
    style.textContent = [
      '.av-edit-mode-badge{margin:0 0 12px;padding:10px 12px;border-radius:14px;background:rgba(199,210,254,.13);border:1px solid rgba(199,210,254,.22);color:rgba(255,255,255,.88);font-size:13px;font-weight:850;}',
      '.av-edit-mode-badge strong{color:#fff;}',
      '.av-edit-mode-notice{margin:0 0 12px;padding:10px 12px;border-radius:14px;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.14);color:rgba(255,255,255,.82);font-size:13px;font-weight:800;}',
      '.av-edit-mode-loading{opacity:.68;pointer-events:none;}'
    ].join('');
    document.head.appendChild(style);
  }

  function getProductRoot() {
    return document.querySelector('[id^="av-product-hero-"]');
  }

  function addNotice(root, message) {
    if (!root || !message) return;

    injectEditStyles();

    var form = qs(root, 'form.av-product-hero__form, form[action*="/cart/add"]');
    if (!form) return;

    var oldNotice = qs(root, '.av-edit-mode-notice');
    if (oldNotice) {
      oldNotice.textContent = message;
      return;
    }

    var notice = document.createElement('div');
    notice.className = 'av-edit-mode-notice';
    notice.textContent = message;
    form.parentNode.insertBefore(notice, form);
  }

  function showStoredNoticeIfNeeded() {
    try {
      var message = window.sessionStorage.getItem('av_edit_mode_notice');
      if (!message) return;

      window.sessionStorage.removeItem('av_edit_mode_notice');

      var root = getProductRoot();
      if (!root) return;

      addNotice(root, message);
    } catch (error) {
      return;
    }
  }

  function cleanEditUrl() {
    var url = new URL(window.location.href);

    url.searchParams.delete('av_edit');
    url.searchParams.delete('av_line_key');
    url.searchParams.delete('av_return');

    return url.pathname + url.search + url.hash;
  }

  function redirectToNormalProduct(message) {
    try {
      if (message) {
        window.sessionStorage.setItem('av_edit_mode_notice', message);
      }
    } catch (error) {
      // Ignore storage failures.
    }

    window.location.replace(cleanEditUrl());
  }

  var params = new URLSearchParams(window.location.search);
  var editConfigId = params.get('av_edit');

  if (!editConfigId) {
    ready(showStoredNoticeIfNeeded);
    return;
  }

  var editLineKey = params.get('av_line_key') || '';
  var returnTarget = params.get('av_return') || 'cart';
  var editModeActive = true;

  var ADDON_VARIANTS = {
    custom_text: '51898142523688',
    extra_color: '51898142556456',
    custom_image_upload: '51898142589224',
    stock_icon: '51898142621992',
    pattern: '51898142654760'
  };

  var ADDON_CONFIG = {
    custom_text: {
      togglePrefix: 'av-enable-custom-text-',
      controlPrefix: 'av-custom-text-',
      propertyName: 'Custom Text',
      emptyMessage: 'Please enter the custom text you want on the box.'
    },
    stock_icon: {
      togglePrefix: 'av-enable-icon-request-',
      controlPrefix: 'av-icon-request-',
      propertyName: 'Icon Request',
      emptyMessage: 'Please enter the icon request you want on the box.'
    },
    extra_color: {
      togglePrefix: 'av-enable-lid-color-',
      controlPrefix: 'av-lid-color-',
      propertyName: 'Color',
      fallbackPropertyName: 'Lid Color',
      emptyMessage: 'Please select a color.'
    }
  };

  function getProps(item) {
    return item && item.properties && typeof item.properties === 'object' ? item.properties : {};
  }

  function getConfigId(item) {
    return trim(getProps(item)._av_config_id);
  }

  function getAddonKey(item) {
    return trim(getProps(item)._av_addon_key);
  }

  function avNormalizeAreaToken(value) {
    return String(value || '')
      .trim()
      .replace(/-/g, '_')
      .replace(/\s+/g, '_')
      .toLowerCase();
  }

  function avTitleizeCustomizationArea(value) {
    var normalized = avNormalizeAreaToken(value);

    var labels = {
      lid: 'Top Lid',
      top: 'Top Lid',
      top_lid: 'Top Lid',

      entire_lid: 'Entire Lid',
      whole_lid: 'Entire Lid',
      lid_color: 'Entire Lid',

      front: 'Front Face',
      front_face: 'Front Face',
      back: 'Back Face',
      back_face: 'Back Face',
      left: 'Left Side',
      left_side: 'Left Side',
      right: 'Right Side',
      right_side: 'Right Side',

      center_stripe: 'Center Stripe',
      seam_stripe: 'Center Stripe',
      stripe: 'Center Stripe',

      lid_stripe: 'Lid Stripe',
      body_stripe: 'Body Stripe',
      base: 'Base'
    };

    if (labels[normalized]) return labels[normalized];

    if (!normalized) return 'Top Lid';

    return normalized
      .replace(/_/g, ' ')
      .replace(/\b\w/g, function (letter) {
        return letter.toUpperCase();
      });
  }

  function avGetAddonKey(addon) {
    if (!addon) return '';
    return String(addon.addonKey || addon.key || addon.type || '').trim();
  }

  function avIsLidColorAddon(addon, context) {
    var key = avNormalizeAreaToken(avGetAddonKey(addon));
    var label = String(
      (addon && (addon.label || addon.title || addon.name)) ||
      (context && (context.label || context.title || context.name)) ||
      ''
    ).toLowerCase();

    return (
      key === 'lid_color' ||
      key === 'lid-color' ||
      label.indexOf('lid color') !== -1
    );
  }

  function avGetCheckoutCustomizationArea(addon, context) {
    context = context || {};

    var key = avNormalizeAreaToken(avGetAddonKey(addon));

    var rawArea =
      (addon && (
        addon.area ||
        addon.surface ||
        addon.zone ||
        addon.renderer_slot ||
        addon.rendererSlot
      )) ||
      context.area ||
      context.surface ||
      context.zone ||
      context.renderer_slot ||
      context.rendererSlot ||
      '';

    // Lid Color applies to the whole lid piece, not just the top face.
    if (avIsLidColorAddon(addon, context)) {
      return 'Entire Lid';
    }

    // Color-zone add-ons should prefer their actual zone/renderer slot.
    if (key === 'extra_color' || key === 'extra-color') {
      var normalizedZone = avNormalizeAreaToken(rawArea);

      if (
        normalizedZone === 'lid' ||
        normalizedZone === 'top_lid' ||
        normalizedZone === 'lid_color' ||
        normalizedZone === 'entire_lid' ||
        normalizedZone === 'whole_lid'
      ) {
        return 'Entire Lid';
      }

      return avTitleizeCustomizationArea(rawArea || 'lid');
    }

    // Current custom text/icon defaults to the lid's top face unless future face data exists.
    if (
      key === 'custom_text' ||
      key === 'custom-text' ||
      key === 'stock_icon' ||
      key === 'stock-icon'
    ) {
      return avTitleizeCustomizationArea(rawArea || 'top_lid');
    }

    return avTitleizeCustomizationArea(rawArea || 'top_lid');
  }

  var BUILDER_DEFINITIONS = window.ArcaverseBuilderRuleDefinitions || {};
  var TEXT_PLACEMENTS = BUILDER_DEFINITIONS.text_placements || {};
  var ICON_PLACEMENTS = BUILDER_DEFINITIONS.icon_placements || {};
  var FONTS = BUILDER_DEFINITIONS.fonts || {};
  var SURFACES = BUILDER_DEFINITIONS.surfaces || {};
  var HORIZONTAL_ALIGNMENTS = BUILDER_DEFINITIONS.horizontal_alignments || {};
  var VERTICAL_ALIGNMENTS = BUILDER_DEFINITIONS.vertical_alignments || {};
  var ORIENTATIONS = BUILDER_DEFINITIONS.orientations || {};
  var ICON_RELATIONS = Object.assign({}, BUILDER_DEFINITIONS.icon_relations_to_text || {}, { independent: { key: 'independent', label: 'Custom position on lid' } });

  function getBuilderSelect(root, type) {
    return qs(root, '[data-av-builder-control="' + type + '"]');
  }

  function getSelectedBuilderDefinition(root, type) {
    var select = getBuilderSelect(root, type);
    var key = trim(select ? select.value : '');
    if (type === 'text-font') return FONTS[key] || null;
    return null;
  }

  function titleCaseDefinition(definitions, key) {
    var definition = definitions[key] || {};
    return definition.label || String(key || '').replace(/_/g, ' ').replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function buildPositionLabel(vertical, horizontal) {
    return titleCaseDefinition(VERTICAL_ALIGNMENTS, vertical) + ' ' + titleCaseDefinition(HORIZONTAL_ALIGNMENTS, horizontal);
  }

  function keyFromLabel(definitions, label) {
    label = trim(label).toLowerCase();
    if (!label) return '';

    for (var key in definitions) {
      if (!Object.prototype.hasOwnProperty.call(definitions, key)) continue;
      var definitionLabel = trim(definitions[key] && definitions[key].label).toLowerCase();
      if (key.toLowerCase() === label || definitionLabel === label) return key;
    }

    return label.replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  }

  function positionPartFromLabel(definitions, label, fallback) {
    var key = keyFromLabel(definitions, label);
    return definitions[key] ? key : fallback;
  }

  function visibleTextVertical(props) {
    var position = trim(props['Text Position']);
    return positionPartFromLabel(VERTICAL_ALIGNMENTS, position.split(/\s+/)[0], 'center');
  }

  function visibleTextHorizontal(props) {
    var position = trim(props['Text Position']);
    var parts = position.split(/\s+/).filter(Boolean);
    return positionPartFromLabel(HORIZONTAL_ALIGNMENTS, parts.length > 1 ? parts[parts.length - 1] : '', 'center');
  }

  function visibleOrientation(props) {
    return positionPartFromLabel(ORIENTATIONS, props['Text Direction'] || props['Text Orientation'], 'horizontal');
  }

  function isTextRelativeIconRelation(relation) {
    return relation === 'left_of_text' || relation === 'right_of_text' || relation === 'above_text' || relation === 'below_text';
  }

  function visibleIconRelation(props) {
    var placement = trim(props['Icon Placement']);
    var relation = keyFromLabel(ICON_RELATIONS, placement);
    if (ICON_RELATIONS[relation]) return relation;
    var horizontal = visibleIconHorizontal(props);
    var vertical = visibleIconVertical(props);
    if (horizontal === 'center' && vertical === 'center') return 'independent';
    return 'independent';
  }

  function visibleIconVertical(props) {
    var placement = trim(props['Icon Placement']);
    return positionPartFromLabel(VERTICAL_ALIGNMENTS, placement.split(/\s+/)[0], 'center');
  }

  function visibleIconHorizontal(props) {
    var placement = trim(props['Icon Placement']);
    var parts = placement.split(/\s+/).filter(Boolean);
    return positionPartFromLabel(HORIZONTAL_ALIGNMENTS, parts.length > 1 ? parts[parts.length - 1] : '', 'center');
  }

  function visibleIconOrientation(props) {
    return positionPartFromLabel(ORIENTATIONS, props['Icon Direction'], 'horizontal');
  }

  function buildRendererSlot(prefix, surface, vertical, horizontal, orientation, relation) {
    if (prefix === 'icon' && relation && relation !== 'independent') return 'icon_' + surface + '_' + relation;
    return prefix + '_' + surface + '_' + vertical + '_' + horizontal + '_' + orientation;
  }

  function getStructuredTextSelection(root) {
    return {
      surface: trim(getBuilderSelect(root, 'text-surface') && getBuilderSelect(root, 'text-surface').value) || 'lid',
      horizontal_align: trim(getBuilderSelect(root, 'text-horizontal') && getBuilderSelect(root, 'text-horizontal').value) || 'center',
      vertical_align: trim(getBuilderSelect(root, 'text-vertical') && getBuilderSelect(root, 'text-vertical').value) || 'center',
      orientation: trim(getBuilderSelect(root, 'text-orientation') && getBuilderSelect(root, 'text-orientation').value) || 'horizontal',
      color: trim(getBuilderSelect(root, 'text-color') && getBuilderSelect(root, 'text-color').value) || 'White'
    };
  }

  function hasCustomTextEnabled(root) {
    var toggle = byIdPrefix(root, 'av-enable-custom-text-');
    return !!(toggle && toggle.checked);
  }

  function getStructuredIconSelection(root) {
    var relation = trim(getBuilderSelect(root, 'icon-relation') && getBuilderSelect(root, 'icon-relation').value) || 'independent';
    if (!hasCustomTextEnabled(root) && isTextRelativeIconRelation(relation)) relation = 'independent';
    var isIndependent = relation === 'independent';
    return {
      surface: 'lid',
      horizontal_align: isIndependent ? (trim(getBuilderSelect(root, 'icon-horizontal') && getBuilderSelect(root, 'icon-horizontal').value) || 'center') : 'center',
      vertical_align: isIndependent ? (trim(getBuilderSelect(root, 'icon-vertical') && getBuilderSelect(root, 'icon-vertical').value) || 'center') : 'center',
      orientation: 'horizontal',
      relation_to_text: relation
    };
  }

  function normalizeKey(value) {
    return String(value || '').toLowerCase().replace(/compatible/g, '').replace(/the/g, '').replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '').trim();
  }

  function getGameValue(root) {
    var selects = qsa(root, '.av-product-option-select');
    if (!selects.length) return '';

    for (var i = 0; i < selects.length; i++) {
      var name = String(selects[i].dataset.optionName || '').toLowerCase();
      if (name.indexOf('game') !== -1 || name.indexOf('layout') !== -1 || name.indexOf('card') !== -1 || name.indexOf('deck size') !== -1) return selects[i].value;
    }

    return selects[0].value;
  }

  function getBuilderRules(root) {
    var rules = parseJson(qs(root, '[id^="av-builder-rules-json-"]'), {});
    return rules && Number(rules.version) === 2 ? rules : {};
  }

  function getBuilderGameOverride(root, rules) {
    var byGame = rules.by_game || {};
    var normalizedGame = normalizeKey(getGameValue(root));
    var keys = Object.keys(byGame);

    for (var i = 0; i < keys.length; i++) {
      if (normalizeKey(keys[i]) === normalizedGame) return byGame[keys[i]] || {};
    }

    for (var j = 0; j < keys.length; j++) {
      var nkey = normalizeKey(keys[j]);
      if (nkey && (normalizedGame.indexOf(nkey) !== -1 || nkey.indexOf(normalizedGame) !== -1)) return byGame[keys[j]] || {};
    }

    return {};
  }

  function getCurrentBuilderColorRules(root) {
    var rules = getBuilderRules(root);
    if (!rules.version) return {};
    var base = rules.default || {};
    var override = getBuilderGameOverride(root, rules);
    var output = {};

    ['included_color_zones', 'paid_color_zones', 'fixed_properties'].forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(override, key)) output[key] = override[key];
      else if (Object.prototype.hasOwnProperty.call(base, key)) output[key] = base[key];
    });

    return output;
  }

  function buildParentProperties(root, configId, productTitle) {
    var primaryColorSelect = qs(root, '[id^="av-primary-color-"]');
    var primaryColor = primaryColorSelect ? primaryColorSelect.value : '';
    var colorRules = getCurrentBuilderColorRules(root);
    var hasBuilderColors = !!((colorRules.included_color_zones || []).length || (colorRules.fixed_properties || []).length);
    var parentProperties = {
      '_av_config_id': configId,
      '_av_parent_product': productTitle,
      '_av_selected_options': getOptionSummary(root),
      '_av_schema': 'arcaverse_edit_mode_v2'
    };

    if (hasBuilderColors) {
      (colorRules.included_color_zones || []).forEach(function (zone) {
        var propertyName = zone.property || zone.label;
        if (propertyName) parentProperties[propertyName] = primaryColor || 'Black';
      });
      (colorRules.fixed_properties || []).forEach(function (property) {
        if (property && property.label) parentProperties[property.label] = property.value || '';
      });
    } else {
      parentProperties['Primary Box Color'] = primaryColor || 'Black';
    }

    return parentProperties;
  }

  function getAddonValue(item, key) {
    var props = getProps(item);

    if (key === 'custom_text') {
      return trim(
        props.Text ||
        props['Custom Text'] ||
        props.Customization ||
        props['Customization Request'] ||
        ''
      );
    }

    if (key === 'stock_icon') {
      return trim(
        props.Icon ||
        props['Icon Request'] ||
        props.Customization ||
        props['Customization Request'] ||
        ''
      );
    }

    if (key === 'extra_color') {
      return trim(
        props.Color ||
        props['Stripe Color'] ||
        props['Accent Color'] ||
        props['Extra Color'] ||
        props['Lid Color Request'] ||
        props['Lid Stripe Color'] ||
        props['Seam Stripe Color'] ||
        props['Center Stripe Color'] ||
        props['Body Stripe Color'] ||
        props['Lid Color'] ||
        props.Customization ||
        props['Customization Request'] ||
        ''
      );
    }

    var config = ADDON_CONFIG[key] || {};

    return trim(
      props[config.propertyName] ||
      props[config.fallbackPropertyName] ||
      props.Value ||
      props.Customization ||
      props['Customization Request'] ||
      ''
    );
  }

  function cartHasConfig(cart, configId) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items.some(function (item) {
      return getConfigId(item) === configId;
    });
  }

  function getGroupFromCart(cart, configId) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];

    return items.filter(function (item) {
      return getConfigId(item) === configId;
    });
  }

  function findParentLine(group) {
    if (!group || !group.length) return null;

    for (var i = 0; i < group.length; i++) {
      if (!getAddonKey(group[i])) {
        if (!editLineKey || group[i].key === editLineKey) {
          return group[i];
        }
      }
    }

    return group.find(function (item) {
      return !getAddonKey(item);
    }) || null;
  }

  function findVariant(variants, variantId) {
    variantId = String(variantId || '');

    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === variantId) {
        return variants[i];
      }
    }

    return null;
  }

  function getVariantOptionsFromCartLine(parentLine, variants) {
    var variant = findVariant(variants, parentLine.variant_id);

    if (variant && Array.isArray(variant.options)) {
      return variant.options;
    }

    if (Array.isArray(parentLine.options_with_values)) {
      return parentLine.options_with_values.map(function (option) {
        return option.value;
      });
    }

    if (Array.isArray(parentLine.variant_options)) {
      return parentLine.variant_options;
    }

    if (parentLine.variant_title && parentLine.variant_title !== 'Default Title') {
      return String(parentLine.variant_title).split(' / ');
    }

    return [];
  }

  function setSelectValue(select, value) {
    if (!select || value == null) return;

    value = String(value);

    var found = false;

    Array.prototype.slice.call(select.options || []).forEach(function (option) {
      if (String(option.value) === value || trim(option.textContent) === value) {
        select.value = option.value;
        found = true;
      }
    });

    if (!found) {
      var newOption = document.createElement('option');
      newOption.value = value;
      newOption.textContent = value;
      select.appendChild(newOption);
      select.value = value;
    }

    dispatchChange(select);
  }

  function setInputValue(control, value) {
    if (!control) return;

    control.disabled = false;
    control.value = value || '';
    dispatchChange(control);
  }

  function getCurrentSelectedOptions(root) {
    return qsa(root, '.av-product-option-select')
      .sort(function (a, b) {
        return Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0);
      })
      .map(function (select) {
        return select.value;
      });
  }

  function findCurrentVariant(root, variants) {
    var selectedOptions = getCurrentSelectedOptions(root);

    if (!variants.length) return null;

    if (!selectedOptions.length) {
      return variants[0];
    }

    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];

      if (!Array.isArray(variant.options) || variant.options.length !== selectedOptions.length) {
        continue;
      }

      var matches = true;

      for (var j = 0; j < selectedOptions.length; j++) {
        if (String(variant.options[j]) !== String(selectedOptions[j])) {
          matches = false;
          break;
        }
      }

      if (matches) {
        return variant;
      }
    }

    return null;
  }

  function getProductTitle(root) {
    var titleEl = qs(root, '.av-product-hero__title');

    return trim(titleEl ? titleEl.textContent : document.title) || 'ArcaVerse Product';
  }

  function getOptionSummary(root) {
    return qsa(root, '.av-product-option-select')
      .map(function (select) {
        var field = select.closest('.av-product-hero__field');
        var labelEl = field ? qs(field, 'label') : null;
        var label = trim(labelEl ? labelEl.textContent : '');

        return label ? label + ': ' + select.value : select.value;
      })
      .filter(Boolean)
      .join(' / ');
  }

  function getAddonsFromForm(root) {
    var addons = [];

    Object.keys(ADDON_CONFIG).forEach(function (key) {
      var config = ADDON_CONFIG[key];
      var optionEls = key === 'extra_color' ? qsa(root, '[data-av-addon-option="extra_color"]') : [];

      if (!optionEls.length) {
        optionEls = [null];
      }

      optionEls.forEach(function (optionEl) {
        var toggle = optionEl ? qs(optionEl, '.av-personalize-toggle') : byIdPrefix(root, config.togglePrefix);
        var control = optionEl ? qs(optionEl, '.av-personalize-control') : byIdPrefix(root, config.controlPrefix);
        var value = trim(control ? control.value : '');

        addons.push({
          key: key,
          config: config,
          toggle: toggle,
          control: control,
          checked: !!(toggle && toggle.checked),
          value: value,
          variantId: ADDON_VARIANTS[key],
          textSelection: key === 'custom_text' ? getStructuredTextSelection(root) : null,
          textFont: key === 'custom_text' ? getSelectedBuilderDefinition(root, 'text-font') : null,
          iconSelection: key === 'stock_icon' ? getStructuredIconSelection(root) : null
        });
      });
    });

    return addons;
  }

  function validateAddons(root) {
    var addons = getAddonsFromForm(root);

    for (var i = 0; i < addons.length; i++) {
      var addon = addons[i];

      if (!addon.checked) continue;

      if (!addon.variantId) {
        return 'The selected add-on is not configured yet.';
      }

      if (!addon.value) {
        return addon.config.emptyMessage;
      }
    }

    return '';
  }

  function buildNewCartGroup(root, variants, oldParentLine) {
    var variant = findCurrentVariant(root, variants);
    var variantInput = qs(root, '[id^="av-selected-variant-id-"]');
    var quantityInput = qs(root, '[id^="av-quantity-"]');
    var parentVariantId = variant ? variant.id : trim(variantInput ? variantInput.value : oldParentLine.variant_id);
    var quantity = Number(quantityInput ? quantityInput.value : oldParentLine.quantity || 1);

    if (!quantity || quantity < 1) quantity = 1;

    quantity = Math.floor(quantity);

    var configId = generateConfigId();
    var productTitle = getProductTitle(root);

    var parentProperties = buildParentProperties(root, configId, productTitle);

    var items = [
      {
        id: Number(parentVariantId),
        quantity: quantity,
        properties: parentProperties
      }
    ];

    getAddonsFromForm(root).forEach(function (addon) {
      if (!addon.checked || !addon.value || !addon.variantId) return;

      var optionEl = addon.toggle ? addon.toggle.closest('.av-product-hero__personalize-option') : null;
      var sectionEl = optionEl ? optionEl.closest('[data-av-ui-section]') : null;
      var sectionKey = sectionEl ? trim(sectionEl.getAttribute('data-av-ui-section')) : '';
      var sectionLabelEl = sectionEl ? qs(sectionEl, '[data-av-ui-section-label]') : null;
      var sectionLabel = trim(sectionLabelEl ? sectionLabelEl.textContent : '');

      var props = {
        'Applies To': productTitle,
        '_av_config_id': configId,
        '_av_addon_key': addon.key,
        '_av_parent_variant_id': String(parentVariantId),
        '_av_schema': 'arcaverse_edit_mode_v2'
      };

      if (sectionKey) {
        props._av_ui_section = sectionKey;
        props._av_ui_section_label = sectionLabel || (sectionKey === 'lid' ? 'Lid' : (sectionKey === 'color_zones' ? 'Color Add-Ons' : sectionKey));
      }

      if (addon.key === 'extra_color') {
        var zoneKey = optionEl ? trim(optionEl.getAttribute('data-av-color-zone')) : '';
        if (zoneKey) {
          props._av_color_zone = zoneKey;
          props._av_renderer_slot = zoneKey;
        }
      }

      if (addon.key === 'custom_text') {
        var text = addon.textSelection || getStructuredTextSelection(root);
        var textFont = addon.textFont || FONTS.standard || { key: 'standard' };
        props['Customization Area'] = avGetCheckoutCustomizationArea(addon, {
          area: text.surface,
          surface: text.surface,
          renderer_slot: buildRendererSlot('text', text.surface, text.vertical_align, text.horizontal_align, text.orientation),
          label: ADDON_CONFIG.custom_text.propertyName
        });
        props['Custom Text'] = addon.value;
        props['Text Color'] = text.color || 'White';
        props['Text Position'] = buildPositionLabel(text.vertical_align, text.horizontal_align);
        props['Text Direction'] = titleCaseDefinition(ORIENTATIONS, text.orientation);
        if (text.surface && text.surface !== 'lid') props['Text Surface'] = titleCaseDefinition(SURFACES, text.surface);
        props._av_text_color = text.color || 'White';
        props._av_text_surface = text.surface;
        props._av_text_horizontal_align = text.horizontal_align;
        props._av_text_vertical_align = text.vertical_align;
        props._av_text_orientation = text.orientation;
        props._av_font_key = textFont ? textFont.key : 'standard';
        props._av_renderer_slot = buildRendererSlot('text', text.surface, text.vertical_align, text.horizontal_align, text.orientation);
      } else if (addon.key === 'stock_icon') {
        var icon = addon.iconSelection || getStructuredIconSelection(root);
        props['Customization Area'] = avGetCheckoutCustomizationArea(addon, {
          area: icon.surface,
          surface: icon.surface,
          renderer_slot: buildRendererSlot('icon', icon.surface, icon.vertical_align, icon.horizontal_align, icon.orientation, icon.relation_to_text),
          label: ADDON_CONFIG.stock_icon.propertyName
        });
        props['Icon Request'] = addon.value;
        props['Icon Placement'] = icon.relation_to_text && icon.relation_to_text !== 'independent' ? titleCaseDefinition(ICON_RELATIONS, icon.relation_to_text) : buildPositionLabel(icon.vertical_align, icon.horizontal_align) + ' on lid';
        props._av_icon_surface = icon.surface;
        props._av_icon_horizontal_align = icon.horizontal_align;
        props._av_icon_vertical_align = icon.vertical_align;
        props._av_icon_orientation = icon.orientation;
        props._av_icon_relation_to_text = icon.relation_to_text;
        props._av_renderer_slot = buildRendererSlot('icon', icon.surface, icon.vertical_align, icon.horizontal_align, icon.orientation, icon.relation_to_text);
      } else if (addon.key === 'extra_color') {
        var labelEl = optionEl ? optionEl.querySelector('.av-product-hero__personalize-name') : null;
        var colorProperty = trim(labelEl ? labelEl.textContent : '') || 'Color';
        if (colorProperty === 'Lid Color Request') colorProperty = 'Lid Color';
        var explicitZone = optionEl ? trim(optionEl.getAttribute('data-av-color-zone')) : '';
        var inferredZone = '';
        if (colorProperty === 'Stripe Color' || colorProperty === 'Seam Stripe Color' || colorProperty === 'Center Stripe Color') {
          inferredZone = 'seam_stripe';
        } else if (colorProperty === 'Lid Stripe Color') {
          inferredZone = 'lid_stripe';
        } else if (colorProperty === 'Body Stripe Color') {
          inferredZone = 'body_stripe';
        } else if (colorProperty === 'Lid Color') {
          inferredZone = 'lid';
        } else {
          inferredZone = 'extra';
        }
        var colorArea = explicitZone || props._av_color_zone || inferredZone;
        props._av_color_zone = colorArea;
        props._av_renderer_slot = colorArea === 'seam_stripe' ? 'seam_stripe' : colorArea;
        props['Customization Area'] = avGetCheckoutCustomizationArea(addon, {
          area: colorArea,
          zone: colorArea,
          renderer_slot: props._av_renderer_slot,
          label: colorProperty
        });
        props[colorProperty] = addon.value;
      } else {
        props[addon.config.propertyName] = addon.value;
      }

      items.push({
        id: Number(addon.variantId),
        quantity: quantity,
        parent_id: Number(parentVariantId),
        properties: props
      });
    });

    return items;
  }

  function stripParentIds(items) {
    return items.map(function (item) {
      var copy = {};

      Object.keys(item).forEach(function (key) {
        if (key !== 'parent_id') copy[key] = item[key];
      });

      return copy;
    });
  }

  function addItems(items, allowFallback) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (response.ok) return response.json();

      return response.json().catch(function () {
        return {};
      }).then(function (body) {
        if (allowFallback) {
          return addItems(stripParentIds(items), false);
        }

        throw new Error(body.description || body.message || 'Could not add the updated configuration.');
      });
    });
  }

  function removeOldGroup(cart, configId) {
    var updates = {};

    (cart.items || []).forEach(function (item) {
      if (getConfigId(item) === configId) {
        updates[item.key] = 0;
      }
    });

    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (response.ok) return response.json();

      return response.json().catch(function () {
        return {};
      }).then(function (body) {
        throw new Error(body.description || body.message || 'Could not remove the old configuration.');
      });
    });
  }

  function addEditBadge(root) {
    if (qs(root, '.av-edit-mode-badge')) return;

    var form = qs(root, 'form.av-product-hero__form, form[action*="/cart/add"]');
    if (!form) return;

    var badge = document.createElement('div');
    badge.className = 'av-edit-mode-badge';
    badge.innerHTML = '<strong>Editing cart item.</strong> Update this configuration, then save it back to your cart.';
    form.parentNode.insertBefore(badge, form);
  }

  function removeEditBadge(root) {
    var badge = qs(root, '.av-edit-mode-badge');
    if (badge) badge.remove();
  }

  function setButtonMode(root, submitting) {
    var button = qs(root, '[id^="av-add-button-"]');
    var label = qs(root, '[id^="av-add-button-label-"]');

    if (button) button.disabled = !!submitting;
    if (label) label.textContent = submitting ? 'Updating...' : 'Update Cart';
  }

  function resetButtonToAddMode(root) {
    var button = qs(root, '[id^="av-add-button-"]');
    var label = qs(root, '[id^="av-add-button-label-"]');

    if (button) button.disabled = false;
    if (label) label.textContent = 'Add to Cart';
  }

  function exitEditModeToNormalProduct(message) {
    editModeActive = false;

    redirectToNormalProduct(message || 'That cart item was removed. You’re viewing a fresh product page.');
  }

  async function fetchCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      return response.json();
    });
  }

  async function loadEditGroup(root, variants) {
    root.classList.add('av-edit-mode-loading');

    var cart = await fetchCart();

    if (!cartHasConfig(cart, editConfigId)) {
      exitEditModeToNormalProduct('That cart item was removed. You’re viewing a fresh product page.');
      return null;
    }

    var group = getGroupFromCart(cart, editConfigId);
    var parent = findParentLine(group);

    if (!parent) {
      exitEditModeToNormalProduct('That cart item was removed. You’re viewing a fresh product page.');
      return null;
    }

    var optionValues = getVariantOptionsFromCartLine(parent, variants);
    var optionSelects = qsa(root, '.av-product-option-select').sort(function (a, b) {
      return Number(a.dataset.optionIndex || 0) - Number(b.dataset.optionIndex || 0);
    });

    optionValues.forEach(function (value, index) {
      if (optionSelects[index]) {
        setSelectValue(optionSelects[index], value);
      }
    });

    await sleep(150);

    var parentProps = getProps(parent);
    var primaryColorSelect = qs(root, '[id^="av-primary-color-"]');

    if (primaryColorSelect) {
      var restoredPrimaryColor = parentProps['Primary Box Color'] || parentProps['Included Lid Color'];
      if (restoredPrimaryColor) setSelectValue(primaryColorSelect, restoredPrimaryColor);
    }

    var quantityInput = qs(root, '[id^="av-quantity-"]');

    if (quantityInput) {
      quantityInput.value = parent.quantity || 1;
    }

    Object.keys(ADDON_CONFIG).forEach(function (key) {
      var config = ADDON_CONFIG[key];

      if (key === 'extra_color') {
        var colorLines = group.filter(function (item) {
          return getAddonKey(item) === key;
        });
        var colorOptions = qsa(root, '[data-av-addon-option="extra_color"]');

        colorOptions.forEach(function (optionEl) {
          var zoneKey = trim(optionEl.getAttribute('data-av-color-zone'));
          var line = colorLines.find(function (item) {
            var props = getProps(item);
            return zoneKey && trim(props._av_color_zone) === zoneKey;
          }) || (colorOptions.length === 1 ? colorLines[0] : null);
          var colorToggle = qs(optionEl, '.av-personalize-toggle');
          var colorControl = qs(optionEl, '.av-personalize-control');

          if (!colorToggle || !colorControl) return;

          if (line) {
            colorToggle.checked = true;
            dispatchChange(colorToggle);
            var colorValue = getAddonValue(line, key);
            if (colorControl.tagName === 'SELECT') {
              setSelectValue(colorControl, colorValue);
            } else {
              setInputValue(colorControl, colorValue);
            }
          } else {
            colorToggle.checked = false;
            dispatchChange(colorToggle);
          }
        });

        return;
      }

      var addonLine = group.find(function (item) {
        return getAddonKey(item) === key;
      });

      var toggle = byIdPrefix(root, config.togglePrefix);
      var control = byIdPrefix(root, config.controlPrefix);

      if (!toggle || !control) return;

      if (addonLine) {
        toggle.checked = true;
        dispatchChange(toggle);

        var value = getAddonValue(addonLine, key);

        if (control.tagName === 'SELECT') {
          setSelectValue(control, value);
        } else {
          setInputValue(control, value);
        }

        var addonProps = getProps(addonLine);
        if (key === 'custom_text') {
          setSelectValue(getBuilderSelect(root, 'text-color'), addonProps._av_text_color || addonProps['Text Color'] || 'White');
          setSelectValue(getBuilderSelect(root, 'text-surface'), addonProps._av_text_surface || (TEXT_PLACEMENTS[addonProps._av_text_slot] || {}).surface || 'lid');
          setSelectValue(getBuilderSelect(root, 'text-horizontal'), addonProps._av_text_horizontal_align || (TEXT_PLACEMENTS[addonProps._av_text_slot] || {}).horizontal_align || visibleTextHorizontal(addonProps));
          setSelectValue(getBuilderSelect(root, 'text-vertical'), addonProps._av_text_vertical_align || (TEXT_PLACEMENTS[addonProps._av_text_slot] || {}).vertical_align || visibleTextVertical(addonProps));
          setSelectValue(getBuilderSelect(root, 'text-orientation'), addonProps._av_text_orientation || (TEXT_PLACEMENTS[addonProps._av_text_slot] || {}).orientation || visibleOrientation(addonProps));
          setSelectValue(getBuilderSelect(root, 'text-font'), addonProps._av_font_key || 'standard');
        } else if (key === 'stock_icon') {
          var legacyIcon = ICON_PLACEMENTS[addonProps._av_icon_slot] || {};
          var iconRelationSelect = getBuilderSelect(root, 'icon-relation');
          var hasCustomTextAddon = group.some(function (item) { return getAddonKey(item) === 'custom_text'; });
          var restoredIconRelation = addonProps._av_icon_relation_to_text || legacyIcon.relation_to_text || legacyIcon.position || visibleIconRelation(addonProps);
          if (!hasCustomTextAddon && isTextRelativeIconRelation(restoredIconRelation)) restoredIconRelation = 'independent';
          setSelectValue(iconRelationSelect, restoredIconRelation);
          setSelectValue(getBuilderSelect(root, 'icon-surface'), addonProps._av_icon_surface || legacyIcon.surface || 'lid');
          setSelectValue(getBuilderSelect(root, 'icon-horizontal'), addonProps._av_icon_horizontal_align || legacyIcon.horizontal_align || visibleIconHorizontal(addonProps));
          setSelectValue(getBuilderSelect(root, 'icon-vertical'), addonProps._av_icon_vertical_align || legacyIcon.vertical_align || visibleIconVertical(addonProps));
          setSelectValue(getBuilderSelect(root, 'icon-orientation'), addonProps._av_icon_orientation || legacyIcon.orientation || visibleIconOrientation(addonProps));
          dispatchChange(iconRelationSelect);
        }
      } else {
        toggle.checked = false;
        dispatchChange(toggle);
      }
    });

    setButtonMode(root, false);
    root.classList.remove('av-edit-mode-loading');

    return { cart: cart, parent: parent, group: group };
  }

  async function recheckStaleEditGroup(root) {
    if (!editModeActive || !editConfigId) return;

    try {
      var cart = await fetchCart();

      if (!cartHasConfig(cart, editConfigId)) {
        exitEditModeToNormalProduct('That cart item was removed. You’re viewing a fresh product page.');
      }
    } catch (error) {
      console.warn('ArcaVerse edit mode stale check failed:', error);
    }
  }

  ready(function () {
    var root = getProductRoot();
    if (!root) return;

    injectEditStyles();
    addEditBadge(root);

    var form = qs(root, 'form.av-product-hero__form, form[action*="/cart/add"]');
    var variants = parseJson(qs(root, '[id^="av-variants-json-"]'), []);
    var editState = null;
    var isSubmitting = false;

    loadEditGroup(root, variants).then(function (state) {
      editState = state;
    }).catch(function (error) {
      console.warn('ArcaVerse edit mode load failed:', error);
      root.classList.remove('av-edit-mode-loading');
      exitEditModeToNormalProduct('Could not load that cart item. You’re viewing a fresh product page.');
    });

    root.addEventListener('change', function () {
      if (!editModeActive) return;

      window.setTimeout(function () {
        setButtonMode(root, false);
      }, 0);
    });

    document.addEventListener('submit', async function (event) {
      if (!form || event.target !== form) return;
      if (!editModeActive || !editConfigId) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (isSubmitting) return;

      var validation = validateAddons(root);

      if (validation) {
        alert(validation);
        return;
      }

      try {
        isSubmitting = true;
        setButtonMode(root, true);

        var freshCart = await fetchCart();

        if (!cartHasConfig(freshCart, editConfigId)) {
          exitEditModeToNormalProduct('That cart item was removed. You’re viewing a fresh product page.');
          return;
        }

        var parentLine = editState && editState.parent ? editState.parent : findParentLine(getGroupFromCart(freshCart, editConfigId));

        if (!parentLine) {
          exitEditModeToNormalProduct('That cart item was removed. You’re viewing a fresh product page.');
          return;
        }

        var newItems = buildNewCartGroup(root, variants, parentLine);

        await addItems(newItems, true);
        await removeOldGroup(freshCart, editConfigId);

        window.location.href = returnTarget === 'cart' ? '/cart' : '/cart';
      } catch (error) {
        console.warn('ArcaVerse edit mode update failed:', error);
        alert(error && error.message ? error.message : 'Could not update this cart configuration. Please try again.');
        isSubmitting = false;

        if (editModeActive) {
          setButtonMode(root, false);
        }
      }
    }, true);

    window.addEventListener('pageshow', function () {
      recheckStaleEditGroup(root);
    });
  });
})();
